module.exports = __webpack_public_path__ + "static/media/white.f50da36e.png";